<template>
  <div id="container">
    <div id="left" class="column"></div>
    <div id="center" class="column">
      <div style="padding: 20px; text-align: center">
        <el-button @click="onThree" type="primary">下载PDF</el-button>
      </div>
      <div class="header-row">
        <div style="height: 1421.42px" id="pdfDom0">
          <div class="header-all" style="height: 1421.42px">
            <div class="tui-reportHeader">
              <img
                src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-6/2022-6-23/20220623135937_1734.png?x-oss-process=style/imgset"
                style="width: 12rem; height: 100%"
                alt=""
                crossOrigin="anonymous"
              />
              <div
                style="
                  position: absolute;
                  top: -20px;
                  left: 0;
                  right: 0;
                  text-align: center;
                "
              >
                <div class="TenanName">{{ $route.query.SchoolName }}</div>
                <div class="tui-reportTitle">
                  幼儿主题评价（{{ $route.query.ClassName }}）
                </div>
              </div>
            </div>
            <div class="header-all-title">
              <div style="font-size: 25px; color: #fff; padding-bottom: 20px">
                {{ $route.query.StudyYearName }}届 {{ $route.query.GradeName }}
              </div>
              <div style="font-size: 25px; color: #fff">
                {{ $route.query.ClassName }}
              </div>
            </div>
          </div>
        </div>
        <template v-if="subjectArr.length != 0">
          <div
            class="tui-Box"
            style="height: 1421px; padding: 0 30px"
            :id="getID(0, 'p3', 1)"
          >
            <div class="themeName">
              {{ $route.query.Title }}
            </div>
            <div
              v-for="(item, index) in subjectArr"
              :key="index"
              style="padding-top: 30px"
            >
              <div class="tui-subjectTitle" style="font-size: 36px">
                {{ item.Title }}：
              </div>
              <div
                class="tui-subjectTitle"
                style="white-space: pre-line; margin-top: -18px"
              >
                {{ item.Desc }}
              </div>
            </div>
          </div>
        </template>
        <!-- P1 -->
        <template>
          <div
            id="pdfDom1"
            style="height: 1421px; padding: 0 30px 0 30px; overflow: hidden"
            class="tui-Box"
          >
            <div class="tui-title">
              {{ Title }}
            </div>
            <el-table
              :data="List"
              border
              :span-method="objectSpanMethod"
              style="width: 100%"
              :header-cell-style="{
                color: '#333',
                textAlign: 'center',
              }"
              :cell-style="{
                padding: '10px 0',
                textAlign: 'center',
                color: '#333',
              }"
              empty-text="暂无数据"
            >
              <el-table-column prop="KeyWord" label="关键词" width="120">
              </el-table-column>
              <el-table-column prop="Describe" label="描述"> </el-table-column>
              <el-table-column label="须努力人数" width="120">
                <template slot-scope="scope">
                  {{ scope.row.ChaNum }}人
                </template>
              </el-table-column>
              <el-table-column label="较好人数" width="90">
                <template slot-scope="scope">
                  {{ scope.row.GoodNum }}人
                </template>
              </el-table-column>
              <el-table-column label="好人数" width="90">
                <template slot-scope="scope">
                  {{ scope.row.VeryGoodNum }}人
                </template>
              </el-table-column>
            </el-table>
          </div>
        </template>
        <div
          class="tui-Box"
          id="pdfDom2"
          style="
            height: 1421.21px;
            padding: 0 30px;
            display: flex;
            align-items: center;
            justify-content: center;
          "
        >
          <div class="tui-echarts">
            <div
              id="echartsAll"
              style="
                width: 100%;
                height: 500px;
                background-color: rgba(255, 255, 255, 0.5);
                padding-top: 20px;
              "
            ></div>
          </div>
        </div>
        <!-- 幼儿 -->
        <div v-for="(items, indexs) in ClassReport" :key="indexs">
          <!-- P1 -->
          <template>
            <div v-if="items.isShowKeyWord">
              <div
                :id="getID(indexs, 'p1', items)"
                class="tui-Box"
                style="height: 1421.21px; overflow: hidden; padding: 0 30px"
              >
                <div class="gradeBox">
                  <div class="evaluateTitle">
                    {{ items.ChildrenName }}
                  </div>
                  <template v-for="(item, index) in items.KeyWordList">
                    <div
                      style="padding: 0 10px"
                      :key="index"
                      v-if="item.DescribeList.length != 0"
                      ref="isOverflow"
                    >
                      <div class="keyword" id="offsetTitle">
                        {{ item.KeyWord }}
                      </div>
                      <div class="table" style="margin: 0">
                        <div class="tableHeader row">
                          <div class="lineOne">描述</div>
                          <div class="lineTwo">需努力</div>
                          <div class="lineThere">较好</div>
                          <div class="lineFour">好</div>
                        </div>
                        <div
                          class="row"
                          v-for="(itemLine, indexLine) in item.DescribeList"
                          :key="indexLine"
                        >
                          <template>
                            <div class="lineOne">
                              {{ itemLine.Text }}
                            </div>
                            <div
                              class="lineTwo"
                              v-for="(itemStar, indexStar) in items.starInfo"
                              :key="indexStar"
                            >
                              <div
                                class="starBox"
                                v-for="(itemStarTwo, indexStarTwo) in itemStar"
                                :key="indexStarTwo"
                                @click="
                                  scoreCheck(
                                    index,
                                    indexLine,
                                    itemStarTwo.Score
                                  )
                                "
                              >
                                <img
                                  v-if="itemLine.Score >= itemStarTwo.Score"
                                  src="../../assets/starActive.png"
                                />
                                <img v-else src="../../assets/star.png" />
                              </div>
                            </div>
                          </template>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
              <!-- P2 -->
            </div>
          </template>
          <div
            class="tui-Box"
            style="
              height: 1421.21px;
              padding: 0 30px;
              display: flex;
              flex-wrap: wrap;
              justify-content: flex-start;
              align-content: flex-start;
            "
            :id="getID(indexs, 'p2', items)"
          >
            <div
              v-for="(product, indexs) in items.imgList"
              :key="indexs"
              :style="{ width: product.ImgList.length >= 3 ? '100%' : '50%' }"
            >
              <div class="tui-Desc">
                <div class="desc-title" style="text-align: center">
                  {{ product.Title }}
                </div>
                <div
                  class="tui-imgs"
                  style="margin: 0 auto"
                  v-if="product.ImgList.length != 0"
                >
                  <img
                    :src="imgs + '?x-oss-process=style/imgset'"
                    style=""
                    class="img"
                    v-for="(imgs, ins) in product.ImgList"
                    :key="ins"
                    crossorigin="anonymous"
                  />
                  <div
                    class="img"
                    v-for="(item, index) in indexs == 0
                      ? 6 - product.ImgList.length
                      : indexs == 1
                      ? 2 - product.ImgList.length
                      : 1 - product.ImgList.length"
                    :key="index"
                  ></div>
                </div>
                <div v-else class="tui-imgs" style="margin: 0 auto">
                  <div
                    class="img"
                    v-for="(item, index) in indexs == 0
                      ? 6
                      : indexs == 1
                      ? 2
                      : 1"
                    :key="index"
                  ></div>
                </div>
                <div class="tui-writing" v-if="product.Text">
                  {{ product.Text }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div :id="getID(0, 'p4', 1)">
          <img
            :src="userImg.BackCoverImg + '?x-oss-process=style/imgset'"
            alt=""
            crossorigin="anonymous"
            style="width: 100%; max-height: 1421px"
          />
        </div>
      </div>
    </div>
    <div id="right" class="column"></div>
  </div>
</template>
<script>
import {
  GetClassReportInfo,
  GetCoverImgByThemeId,
  MsaveImage,
  SetAutoPdfInfo,
  GetThemeDesc,
} from "../../api/api";
import html2Canvas from "html2canvas";
import download from "../../../util/downLoad";
export default {
  data() {
    return {
      List: [],
      imgList: [],
      userImg: {},

      Title: "",
      spanArr: [], //二维数组，用于存放单元格合并规则
      position: 0, //用于存储相同项的开始index
      ClassReport: [],
      GuidList: [],
      subjectArr: [],
    };
  },
  created() {
    this.GetCoverImgByThemeId();
    this.GetThemeDesc();
    this.GetClassReportInfo();
  },
  methods: {
    async GetThemeDesc() {
      let res = await GetThemeDesc({ ThemeId: this.$route.query.ThemeId });
      if (res.data.success) {
        this.subjectArr = res.data.response;
      }
    },
    guid() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (Math.random() * 16) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );
    },
    getID(index, type, item) {
      if (type == "p1") {
        var num = 2;
        var content = 0;
        content += num * index + 1 + 2;

        return "pdfDom" + content;
      } else if (type == "p2") {
        var num = 2;
        var content = 0;
        content += num * index + 2 + 2;

        return "pdfDom" + content;
      } else if (type == "p3") {
        var Num = this.ClassReport.length * 2 + 3;
        return "pdfDom" + Num;
      } else if (type == "p4") {
        var Num = this.ClassReport.length * 2 + 4;
        //console.log("pdfDom" + Num, "aa");
        return "pdfDom" + Num;
      }
    },
    rowspan(idx, prop) {
      this.spanArr[idx] = [];
      this.position = 0;
      this.List.forEach((item, index) => {
        if (index === 0) {
          this.spanArr[idx].push(1);
          this.position = 0;
        } else {
          if (this.List[index][prop] === this.List[index - 1][prop]) {
            this.spanArr[idx][this.position] += 1; //有相同项
            this.spanArr[idx].push(0); // 名称相同后往数组里面加一项0
          } else {
            this.spanArr[idx].push(1); //同列的前后两行单元格不相同
            this.position = index;
          }
        }
      });
    },
    //表格单元格合并
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      for (let i = 0; i < 1; i++) {
        if (columnIndex == i) {
          const _row = this.spanArr[i][rowIndex];
          const _col = _row > 0 ? 1 : 0;

          return {
            rowspan: _row,
            colspan: _col,
          };
        }
      }
    },
    // 获取封面封底
    GetCoverImgByThemeId() {
      GetCoverImgByThemeId({ Id: this.$route.query.ThemeId }).then((res) => {
        if (res.data.success) {
          this.userImg = res.data.response;
        }
      });
    },
    // 获取报告
    GetClassReportInfo() {
      const params = {
        Eval_ThemeId: this.$route.query.ThemeId,
        StudyYearName: this.$route.query.StudyYearName,
        GradeName: this.$route.query.GradeName,
        GradeId: this.$route.query.GradeId,
        StudyYearId: this.$route.query.StudyYearId,
        ClassId: this.$route.query.ClassId,
      };

      GetClassReportInfo(params).then((res) => {
        if (res.data.success) {
          this.List = res.data.response.List;
          this.Title = res.data.response.Title;
          this.rowspan(0, "KeyWord");
          for (let i = 0; i < res.data.response.ClassReport.length; i++) {
            let item = res.data.response.ClassReport[i];
            let imgList = [];
            imgList.push(...item.secondDesc);
            // 获取星星评分的结构
            item.starInfo = this.distinguish(item.Type);
            // 判断是否有评分题
            let isShowKeyWord = false;
            for (let j = 0; j < item.KeyWordList.length; j++) {
              // 删选出分数为0的
              item.KeyWordList[j].DescribeList = item.KeyWordList[
                j
              ].DescribeList.filter((itemFilter) => {
                return itemFilter.Score != 0;
              });
            }
            for (let j = 0; j < item.KeyWordList.length; j++) {
              // 存在一项评分题即存在
              if (item.KeyWordList[j].DescribeList.length != 0) {
                isShowKeyWord = true;
                break;
              }
            }
            item.isShowKeyWord = isShowKeyWord;
            item.imgList = imgList;
          }
          this.ClassReport = res.data.response.ClassReport;
          this.$nextTick(() => {
            let echarts = document.getElementById("echartsAll");

            let myChart;
            if (echarts) {
              myChart = this.$echarts.init(echarts);
            }
            let Servers = [];

            Servers = res.data.response.Series.map((item, index) => {
              return {
                data: item.data,
                type: "bar",
                name: item.name,
                barWidth: 30,
                barMaxWidth: 20,
              };
            });

            let option = {
              color: ["#FAA271", "#67C793", "#6E84E7"],
              tooltip: {
                trigger: "axis",
                formatter: function (params, ticket, callback) {
                  //console.log(params, "params");
                  let str = params[0].axisValue + " <br/>";
                  let total = 0;
                  params.forEach((item) => {
                    total += item.value;
                  });
                  params.forEach((item) => {
                    str += `${item.seriesName}:${
                      (item.value / total) * 100
                    }% <br/>`;
                  });
                  return str;
                },
                axisPointer: {
                  type: "cross",
                  crossStyle: {
                    color: "#999",
                  },
                },
              },
              legend: {
                data: res.data.response.legendData,
                top: 0,
                right: 20,
                itemWidth: 16,
                itemHeight: 16,
                textStyle: {
                  //图例文字的样式

                  fontSize: 16,
                },
              },
              xAxis: [
                {
                  axisLabel: {
                    align: "center",
                    interval: 0,
                    fontSize: "20",
                    width: 30,
                  },
                  type: "category",
                  data: res.data.response.Xaxis_data,
                  axisPointer: {
                    type: "shadow",
                  },
                },
              ],
              yAxis: [
                {
                  axisTick: {
                    show: false, //不显示坐标轴刻度线
                  },
                  axisLine: {
                    show: true, //不显示坐标轴线
                  },
                  type: "value",
                  // name: "Precipitation",
                  interval: 5,
                  minInterval: 5,
                  name: "单位（人数）",
                  nameTextStyle: {
                    color: "#aaa",
                    nameLocation: "start",
                  },
                },
              ],
              series: Servers,
            };
            myChart.setOption(option, true);
            window.addEventListener("resize", () => {
              myChart.resize();
            });
          });
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
          });
        }
      });
    },
    distinguish(Type) {
      let starInfo = [];
      // 三个子数组对应是哪个分数的单元格 子数组中的对象代表一个星星信息 score选择获得的分数
      if (Type == 1) {
        starInfo = [
          [
            {
              Score: 1,
            },
            {
              Score: 2,
            },
            {
              Score: 3,
            },
          ],
          [
            {
              Score: 4,
            },
            {
              Score: 5,
            },
            {
              Score: 6,
            },
          ],
          [
            {
              Score: 7,
            },
            {
              Score: 8,
            },
            {
              Score: 9,
            },
          ],
        ];
      } else {
        starInfo = [
          [
            {
              Score: 1,
            },
          ],
          [
            {
              Score: 2,
            },
          ],
          [
            {
              Score: 3,
            },
          ],
        ];
      }
      return starInfo;
    },
    uq(array) {
      //将array数组转换成set对象,再使用Array.from()方法将set对象转换成数组
      return Array.from(new Set(array));
    },
    /*
     * 使用download.js 强制浏览器下载图片、视频等文件
     * @param {any} url url链接地址
     * @param {any} strFileName 文件名
     * @param {any} strMimeType 文件类型
     * dzl
     */
    downloadfile(url, strFileName, strMimeType) {
      var xmlHttp = null;
      if (window.ActiveXObject) {
        // IE6, IE5 浏览器执行代码
        xmlHttp = new ActiveXObject("Microsoft.XMLHTTP");
      } else if (window.XMLHttpRequest) {
        // IE7+, Firefox, Chrome, Opera, Safari 浏览器执行代码
        xmlHttp = new XMLHttpRequest();
      }
      //2.如果实例化成功，就调用open（）方法：
      if (xmlHttp != null) {
        xmlHttp.open("get", url, true);
        xmlHttp.responseType = "blob"; //关键
        xmlHttp.send();
        xmlHttp.onreadystatechange = doResult; //设置回调函数
      }
      function doResult() {
        if (xmlHttp.readyState == 4) {
          //4表示执行完成
          if (xmlHttp.status == 200) {
            //200表示执行成功

            download(xmlHttp.response, strFileName, strMimeType);
          }
        }
      }
    },
    onThree() {
      const loading = this.$loading({
        lock: true,
        text: "正在下载PDF",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      let Num = this.ClassReport.length * 2 + 5;
      let that = this;
      let pageSize = 10;
      let page = Math.ceil(Num / pageSize);
      var i = 0;
      // 递归函数
      async function fn() {
        let End =
          pageSize * i + pageSize <= Num ? pageSize * i + pageSize : Num;
        let pageBase = [];
        for (let index = pageSize * i; index < End; index++) {
          let content = document.querySelector("#pdfDom" + index);
          //console.log(content, "sssssss");
          let canvas = await html2Canvas(content, {
            useCORS: true,
            dpi: 172, //导出pdf清晰度
            scale: 2, // 提升画面质量，但是会增加文件大小
          });
          let pageData = canvas.toDataURL("image/jpeg", 1.0);
          pageBase.push({
            guid: index + 100 + "_" + that.guid(),
            baseimg: pageData,
            name: "#pdfDom" + index,
          });
          // that.GuidList.splice(index, 1, pageBase);
          //console.log(pageBase);

          // that.GuidList.push(...pageBase);
        }
        that.GuidList = that.GuidList.concat(pageBase);
        i++;
        // //console.log(pageBase)

        let xhr = await MsaveImage({
          name: "班级主题报告",
          list: pageBase,
        });

        //console.log("第" + i + "次qingqiu");
        if (i < page) {
          setTimeout(() => {
            fn();
          }, 500);
        } else {
          SetAutoPdfInfo({
            name: `${that.$route.query.GradeName}${that.$route.query.ClassName}班级主题报告`,
            list: that.uq(that.GuidList),
          }).then((res) => {
            loading.close();
            if (res.data.success) {
              let idx = res.data.response.lastIndexOf(".");
              if (idx != -1) {
                let ext = res.data.response.substr(idx + 1).toUpperCase();
                ext = ext.toLowerCase();
                that.downloadfile(
                  res.data.response,
                  `${that.$route.query.GradeName}${that.$route.query.ClassName}班级主题报告`,
                  ext
                );
              }
            } else {
              that.$message({
                type: "error",
                message: res.data.msg,
              });
            }
          });
        }
      }
      fn();
    },
  },
};
</script>
<style lang="less" scoped>
.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.tui-subjectName {
  font-size: 16px;
  color: #333;
  font-weight: 500;
  padding: 20px 0;
}
/*最外层透明*/
/deep/ .el-table,
/deep/ .el-table__expanded-cell {
  background-color: transparent;
}
/* 表格内背景颜色 */
/deep/ .el-table th,
/deep/ .el-table tr,
/deep/ .el-table td {
  background-color: transparent;
}
/deep/.el-table th.el-table__cell {
  background-color: transparent;
}
/deep/.el-table--border,
/deep/.el-table--group {
  border-color: #666666;
}

/deep/.el-table--border:after,
/deep/.el-table--group:after,
/deep/.el-table:before {
  background-color: #666666;
}

/deep/.el-table td,
/deep/.el-table--border th,
/deep/.el-table th.is-leaf {
  border-bottom-color: #666666 !important;
}

/deep/.el-table--border td,
/deep/.el-table--border th {
  border-right-color: #666666;
}
.tui-title {
  text-align: center;
  font-size: 40px;
  font-weight: 500;
  color: #333333;
  padding: 20px 0;
}
.tui-echarts {
  width: 800px;
  height: 650px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.tui-Box {
  background: url(../../assets/SubjectResult-bg.png) no-repeat center center;
  background-size: cover;
}
.themeName {
  text-align: center;
  font-size: 30px;
  padding-top: 50px;
}
.tui-Desc {
  padding: 0 10px;
  .desc-title {
    font-size: 36px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    padding: 28px 0;
  }
  .tui-father {
    display: flex;
    justify-content: space-between;
    .tui-imgContent:nth-child(2) {
      margin-left: 20px;
    }
  }
  .tui-imgs {
    max-width: 700px;
    display: flex;
    justify-content: center;
    margin: 0 auto;
    flex-wrap: wrap;
    .img {
      margin-right: 15px;
      margin-bottom: 15px;
      width: 180px;
      background-color: #f1f2f7;
      height: 180px;
      object-fit: cover;
    }

    .img:nth-child(3n + 3) {
      margin-right: 0;
    }
    .img:last-child {
      margin-right: 0;
    }
  }
  .tui-writing {
    font-size: 18px;
    font-family: "font";
    font-weight: 400;
    color: #333333;
    line-height: 22px;
    min-height: 180px;
  }
}
.tui-subjectTitle {
  font-size: 18px;
  font-family: "font";
  font-weight: 400;
  color: #333333;
  line-height: 22px;
  padding: 20px 0;
}
.gradeBox {
  width: 100%;

  // box-shadow: 0px 4px 32px 3px rgba(57, 87, 181, 0.15);
  margin: 0 auto;

  .evaluateTitle {
    text-align: center;
    font-size: 40px;
    font-weight: 400;
    color: #333333;
    text-align: center;
    padding: 0 30px;
    padding-top: 33px;
    border-bottom: 1px solid #cdcdcd;
    padding-bottom: 22px;
  }

  .keyword {
    text-align: center;
    line-height: 64px;
    font-size: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #305a9f;
    font-weight: 500;
  }

  .table {
    .tableHeader {
      border-top: 1px solid #cdcdcd;

      view {
        color: #000000 !important;
      }

      .lineOne {
        padding: 10px 0;
        width: 300px;
        text-align: center;
        font-size: 14px;
      }
    }

    .row {
      display: flex;
      border-bottom: 1px solid #cdcdcd;

      img {
        width: 27px;
        height: 26px;
      }

      .starBox {
        padding: 0px;
      }

      view {
        padding: 10px;
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 300;
        color: #666666;
      }

      .lineOne {
        padding: 10px;
        width: 470px;
        border-right: 1px solid #cdcdcd;
        border-left: 1px solid #cdcdcd;
        font-size: 14px;
      }

      .lineTwo {
        flex: 1;
        text-align: center;
        border-right: 1px solid #cdcdcd;
        display: flex;
        justify-content: space-around;
        align-items: center;
        font-size: 22px;
      }

      .lineThere {
        flex: 1;
        text-align: center;
        border-right: 1px solid #cdcdcd;
        display: flex;
        justify-content: space-around;
        align-items: center;
        font-size: 22px;
      }

      .lineFour {
        flex: 1;
        text-align: center;
        display: flex;
        justify-content: space-around;
        align-items: center;
        font-size: 22px;
        border-right: 1px solid #cdcdcd;
      }
    }
  }
}
.header-all {
  height: 100%;
  background: url(../../assets/newBG.png) no-repeat center center;
  background-size: 100% 100%;
  position: relative;
  .tui-reportHeader {
    width: 100%;
    margin: 0 auto;
    position: absolute;
    top: 190px;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    .TenanName {
      font-size: 40px;
      color: #fff;
    }
    .tui-reportTitle {
      font-size: 60px;
      color: #fff;
      padding-top: 20px;
    }
    .tui-class {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 20px;

      span {
        width: 0.225rem;
        height: 0.225rem;
        border-radius: 50%;
        background: #ffec8e;
      }
      div {
        font-size: 0.375rem;
        color: #ffec8e;
        font-weight: 600;
        letter-spacing: 0.0625rem;
        padding: 0 0.25rem;
      }
    }
  }
  .header-Name {
    text-align: center;
    text-shadow: 0px 6px 1px #fff;
    font-size: 70px;
    font-family: Lantinghei SC;
    font-weight: 800;
    color: #3ec53f;
    padding-top: 111px;
  }
  .tui-headerName {
    font-size: 73px;
    font-weight: bold;
    text-align: center;
    color: #4f6585;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 60px;
  }
  .tui-headerTitle {
    width: 717px;
    height: 184px;
    font-size: 84px;
    font-weight: bold;
    text-align: center;
    color: #4f6585;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .header-all-title {
    position: absolute;
    bottom: 43px;
    left: 0;
    right: 0;

    display: flex;
    align-items: center;
    flex-direction: column;
  }
}
#header,
#footer {
  background: rgba(29, 27, 27, 0.726);
  text-align: center;
  height: 60px;
  line-height: 60px;
}
#container {
  background: #fff;
  display: flex;
}
#container .column {
  height: 100%;
  /* line-height: 300px; */
}
#center {
  width: 1000px;
  background: #fff;
}
#left {
  flex: 1;
}
#right {
  flex: 1;
}
.textOverflow {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>